// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ug79","tabsBox":"styles_tabsBox__RhFZs","createButton":"styles_createButton__3TME-"};